var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      style: { background: _vm.background, "max-width": _vm.maxWidth },
      attrs: { id: "side-menu" }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/js/components/side-menu/side-menu.vue